
define('known/views/userHeaderView',[
	'jquery',
	'underscore',
	'backbone',
	'known/models/userModel'
], function($, _, Backbone, UserModel){
	var UserHeaderView = Backbone.View.extend({
		el: $("#topMenuUserName"),
		
		initialize: function(options) {
			this.listenTo(this.model, 'change', this.render);
		},
		
		render: function () {
			$(this.el).html(this.model.prettyDispName());
			
			if(this.model.isGuest()){
				$("#hdrUserLogin").show();
				$("#hdrUserRegister").show();
				$("#hdrUserAccount").hide();
				$("#hdrUserLogout").hide();
			} else {
				$("#hdrUserLogin").hide();
				$("#hdrUserRegister").hide();
				$("#hdrUserAccount").show();
				$("#hdrUserLogout").show();
			}
			
			return this;
		}
	});
	
	return UserHeaderView;  
});